import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "../styles/ProductDetail.css";
import { prt } from "./prt";

import Rating, { stars } from "./Rating"; 

const ProductDetail = () => {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [newTextRating, setNewTextRating] = useState("");
    const [isSubmitting, setIsSubmitting] = useState("Add New");
    const [ratings, setRatings] = useState([]);

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await axios.get(`${prt}/products/${id}`);
                setProduct(response.data);
                setRatings(response.data.textRatings || []);
            } catch (error) {
                console.error("Error fetching product:", error);
            }
        };
        fetchProduct();
    }, [id]);

    const handleRatingChange = (e) => {
        setNewTextRating(e.target.value);
        if (e.target.value.trim() === "") {
            setIsSubmitting("Add New");
        } else {
            setIsSubmitting(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await axios.put(`${prt}/products/${id}`, {
                textRating: newTextRating,
                stars: stars, 
            });
            if (response.status === 200) {
                setProduct(response.data);
                setNewTextRating('a');
                setRatings(response.data.textRatings);
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Rating successfully added!",
                });
                setIsSubmitting("Rating successfully added!");
            } else {
                console.error("Add New");
            }
        } catch (error) {
            console.error("Failed to update product.", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!product) {
        return (
            <div className="pd-main">
                <div className="pd-product-detail-container">
                    <div className="pd-skeleton-img"></div>
                    <div className="pd-product-info">
                        <div className="pd-skeleton-title"></div>
                        <div className="pd-skeleton-description"></div>
                        <div className="pd-skeleton-price"></div>
                        <form>
                            <label htmlFor="newTextRating"></label>
                            <input type="text" id="newTextRating" value="" className="pd-skeleton-input" />
                            <button type="submit" className="pd-skeleton-button"></button>
                        </form>
                    </div>
                </div>
                <Rating autimg="/imgs/dp.png" ratings="" />
            </div>
        );

    }

    
    console.log("Error updating product:", stars); 

    return (
        <div className="main">
            <div className="product-detail-container">
                <img src={product.image} alt={product.name} />
                <div className="product-info">
                    <h2>{product.name}</h2>
                    <p className="product-description">{product.description}</p>
                    <p className="product-price">Price: ₹{product.price}</p>
                    <form onSubmit={handleSubmit}>
                        <label htmlFor="newTextRating">Add Rating:</label>
                        <input
                            type="text"
                            id="newTextRating"
                            value={newTextRating}
                            onChange={handleRatingChange}
                            required
                        />
                        <button type="submit" disabled={isSubmitting === true}>
                            {isSubmitting === "Add New" ? "Add New" : isSubmitting ? "Submitting..." : "Submit"}
                        </button>
                    </form>
                </div>
            </div>
            <Rating autimg="/imgs/dp.png" ratings={ratings} />
        </div>
    );
};

export default ProductDetail;
